export enum SupportTypes {
    GeneralSupport,
    Tech,
    Feature,
    MachineLearning,
    Media,
    RequestMlMeasurement,
}
